export const PAGINATION_UPDATE_EXPERIMENT =
  'car-merch-ui-srp-pagination-update';
